import * as z from "zod";

export const connectGorgiasPrivateApp = {
  name: "connectGorgiasPrivateApp" as const,
  input: z.object({
    account: z.string(),
    apiEmail: z.string(),
    apiKey: z.string(),
    smsPhoneNumber: z.string().optional(),
  }),
  output: z.object({
    success: z.boolean(),
    account: z.nullable(z.string()),
    error: z.string().optional(),
  }),
};
